import { createAction, EmptyActionCreator } from 'redux-act';

import {
  CategorizedMenuItemsResponse,
  SavedRestaurantVoucher,
  UserSavedRestaurantVouchers,
} from '../../../core/api/payment/payment.types';
import * as Data from '../../Data';

const MODULE_ID = 'FD_CONFIG_PAYMENT_';

const createPaymentAction = <T>(type: string) =>
  createAction<T>(`${MODULE_ID}${type}`);

export const setState =
  createPaymentAction<WebOrder.State.Payments>('SET_STATE');

export const setStatus = createPaymentAction<{
  error?: Error;
  status: WebOrder.State.Payments['status'];
}>('SET_STATUS');

export const setPayment =
  createPaymentAction<WebOrder.State.Payment>('SET_ITEM');
export const updatePayment = createPaymentAction<
  Partial<WebOrder.State.Payment> & { paymentId: string }
>('UPDATE_ITEMS');

// #region restaurant vouchers
export const setRestaurantVouchers = createPaymentAction<
  Data.Async<UserSavedRestaurantVouchers> & { prId: number }
>('SET_RESTAURANT_VOUCHERS');

export const addSavedRestaurantVoucher = createPaymentAction<
  Data.Async<SavedRestaurantVoucher> & { prId: number }
>('ADD_SAVED_RESTAURANT_VOUCHER');

export const setCanApplyRestaurantVoucher = createPaymentAction<
  Data.Async<CategorizedMenuItemsResponse>
>('SET_CATEGORIZED_MENUITEMS');
// #endregion

// #region just events
export type CreditCardPaymentAddedProps = {
  cardNumber: string;
  hasConsentToSaveCard: boolean;
  paymentAccountId: number;
};

export const creditCardPaymentAdded =
  createPaymentAction<CreditCardPaymentAddedProps>('CREDIT_CARD_ADDED');

export const paymentRemoved = createPaymentAction<{
  paymentId: string;
}>('PAYMENT_REMOVED');

export const setDefaultSelected = createPaymentAction<{
  paymentId: string;
}>('SET_DEFAULT');

export const initializeStripe = createPaymentAction(
  'INITIALIZE_STRIPE',
) as EmptyActionCreator;

/** (TEMPORARY) one way bridge from old actions and new sagas world */

export const cancelAddBridge = createPaymentAction(
  'CANCEL_ADD_BRIDGE',
) as EmptyActionCreator;
// #endregion
